import { useScrollParallax, useMouseParallax } from './modules/_fn.js'

const createYoutubeScript = () => {
  const tag = document.createElement('script')
  tag.src = "https://www.youtube.com/player_api"
  const firstScriptTag = document.getElementsByTagName('script')[0]
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
}

const useGetYoutubeId = (url) => {
	const patterns = [
		/(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^&]+)/,
		/(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([^/?]+)/,
		/(?:https?:\/\/)?(?:www\.)?youtube\.com\/v\/([^/?]+)/,
		/(?:https?:\/\/)?youtu\.be\/([^/?]+)/
	]

	for (const pattern of patterns) {
		const match = url.match(pattern)
		if (match && match[1]) {
			return match[1]
		}
	}

	return null
}

const youtubePlayers = []

window.onYouTubePlayerAPIReady = () => {
	const iframeSources = [...document.querySelectorAll('[data-video-src]')]
	console.log(iframeSources)
	if (!iframeSources.length) return

	iframeSources.forEach((iframeSource, index) => {
    const youtubeId = useGetYoutubeId(iframeSource.dataset.videoSrc)
    if (!youtubeId) return

		iframeSource.id = youtubeId
    youtubePlayers[index] = new YT.Player(youtubeId, {
      videoId: youtubeId
    })
  })
}

const useGallerySwiper = () => {
	const swiperName = '.gallery__swiper'
	const swiperEl = document.querySelector(swiperName)
	if (!swiperEl) return

	const gallerySlide = document.querySelectorAll('.gallery__slide')

	const options = {
		speed: 500,
		slidesPerView: 'auto',
		spaceBetween: 8,
		pagination: {
			el: '.gallery__swiper__pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.gallery__swiper__btn--next',
			prevEl: '.gallery__swiper__btn--prev',
		},
		breakpoints: {
			768: {
				spaceBetween: 12,
			},
			1024: {
				spaceBetween: 20,
			}
		}
	}

	new Swiper(swiperName, options)

	// modal gallery
	const modalGallerySwiper = useModalGallerySwiper()

	gallerySlide.forEach((slide, index) => {
		slide.addEventListener('click', () => {
			modalGallerySwiper.slideTo(index, 0)
		})
	})
}

const useVideoSwiper = () => {
	const swiperName = '.video__swiper'
	const swiperEl = document.querySelector(swiperName)
	if (!swiperEl) return

	const options = {
		speed: 500,
		slidesPerView: 1,
		spaceBetween: 8,
		pagination: {
			el: '.video__swiper__pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.video__swiper__btn--next',
			prevEl: '.video__swiper__btn--prev',
		},
		breakpoints: {
			768: {
				spaceBetween: 12,
			},
			1024: {
				spaceBetween: 20,
			}
		},
		on: {
			slideChange: (swiper) => {
				const activeIndex = swiper.activeIndex
				youtubePlayers.forEach((player, index) => {
					if (index !== activeIndex) {
						player.stopVideo()
					}
				})
			}
		}
	}

	new Swiper(swiperName, options)
}

const useAccessorySwiper = () => {
	const swiperName = '.accessory__swiper'
	const swiperEl = document.querySelector(swiperName)
	if (!swiperEl) return

	const options = {
		speed: 500,
		slidesPerView: 'auto',
		spaceBetween: 8,
		pagination: {
			el: '.accessory__swiper__pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.accessory__swiper__btn--next',
			prevEl: '.accessory__swiper__btn--prev',
		},
		breakpoints: {
			768: {
				spaceBetween: 12,
			},
			1024: {
				spaceBetween: 20,
			}
		}
	}

	new Swiper(swiperName, options)
}

const useModalGallerySwiper = () => {
	const swiperName = '.modal-gallery__swiper'
	const swiperEl = document.querySelector(swiperName)
	if (!swiperEl) return

	const options = {
		speed: 500,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		navigation: {
			nextEl: '.modal-gallery__swiper__btn--next',
			prevEl: '.modal-gallery__swiper__btn--prev',
		},
	}

	return new Swiper(swiperName, options)
}

document.addEventListener('DOMContentLoaded', () => {
	createYoutubeScript()
	useGallerySwiper()
	useVideoSwiper()
	useAccessorySwiper()
	useScrollParallax()
	useMouseParallax()
})
